import { Store } from '@ngxs/store';
import { defer, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { ignoreNullish, Loadable, LoadableStatus, Logger } from '@aiwyn/shared';

import { TypedIdentity } from '../models';

export abstract class AbstractBaseCommonClientRequestController<Identity extends TypedIdentity, Model, TypeClass> {
  constructor(
    public readonly identity: Identity,
    protected readonly _store: Store,
    protected readonly _logger: Logger,
  ) {}

  model$: Observable<Loadable<Model>>;

  loadableStatus$: Observable<LoadableStatus> = defer(() => this.model$).pipe(
    ignoreNullish(),
    map(({ status }) => status),
  );

  data$: Observable<Model> = defer(() => this.model$).pipe(
    ignoreNullish(),
    map(({ data }) => data),
  );

  typeClass$: Observable<TypeClass> = defer(() => this._create$(this.model$, this._store, this._logger)).pipe(
    shareReplay<TypeClass>(1),
  );

  protected abstract _create$(
    model$: Observable<Loadable<Model>>,
    store: Store,
    logger: Logger,
    ...params: unknown[]
  ): Observable<TypeClass>;
}
